function Chiclet(item,attribute,refine)
{
	const container = document.querySelector('#cs-chicklets');
	const chiclet = document.querySelector(`.brookings-chiclet[data-value="${item.value}"][data-type="${attribute}"]`);

	if ( item.isRefined && !chiclet ) {
		const chiclet = document.createElement('button');
		chiclet.classList.add('feed--filtered__chiclet', 'brookings-chiclet', 'active');
		chiclet.setAttribute('data-type', attribute);
		chiclet.setAttribute('data-value', item.value);
		chiclet.textContent = item.label;
		container.appendChild(chiclet);
		chiclet.addEventListener('click', () => {
			if ( 'post_date' === chiclet.getAttribute('data-type') ) {
				const timeNow = Math.floor(Date.now() / 1000);
				const one_hundred_years_ago = Math.floor(Date.now() / 1000) - 3153600000;
				refine(`%7B%22start%22:${one_hundred_years_ago},%22end%22:${timeNow}%7D`);
			} else {
				refine(item.value);
			}
			chiclet.remove();
		});
	} else if ( !item.isRefined && chiclet ) {
		chiclet.remove();
	}
}

export default Chiclet;